import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const CarouselControl = (props, context) => {
  const {
    children,
    direction,
    onClickHandler,

    directionText,
    className
  } = props;
  const BS = context.theme;

  return (
    <a
      className={cx(
        className ? BS[className] || className : undefined,
        BS[`carousel-control-${direction}`]
      )}
      role="button"
      tabIndex="0"
      onClick={e => {
        e.preventDefault();
        onClickHandler();
      }}
    >
      <span className={cx(BS[`carousel-control-${direction}-icon`])} aria-hidden="true">
        {children}
      </span>
      <span className={cx(BS[`sr-only`])}>{directionText || direction}</span>
    </a>
  );
};

CarouselControl.propTypes = {
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
  onClickHandler: PropTypes.func.isRequired,
  directionText: PropTypes.string,
  className: PropTypes.string
};

CarouselControl.contextTypes = {
  theme: PropTypes.object
};

export default CarouselControl;



// WEBPACK FOOTER //
// ./src/components/carousel/carousel-control.js